<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">後で見るの削除</span>
        </div>
        <div class="popup-content">
          <p class="txt">
            この後で見るを削除してもよろしいですか？
          </p>
          <div class="button mt32"
            @click="submit"
          >
            <span role="button" class="btn">削除</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  setup (props, context) {
    const store = context.root.$store
    const { viewLater } = store.state

    const close = () => {
      context.emit('closeViewLaterDeleteConfirm')
    }
    const submit = async() => {
      const params = {
        id: viewLater.currentId
      }
      await store
        .dispatch('viewLater/delete', params)
        .then(() => {
          store.dispatch('common/showToast', {
            text: '後で見るを削除しました'
          })
        })
      context.emit('closeViewLaterDeleteConfirm')
    }

    return {
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
